export function section01() {
    gsap.from(".section#section-1 .giant-text", {
        y: "125px",
        scrollTrigger: {
            trigger: ".section#section-1",
            start: "center bottom",
            end: "bottom top",
            scrub: true,
            once: false,
        },
    })
    gsap.from(".section#section-1 .copy-wrapper p", {
        opacity: 0,
        stagger: 0.15,
        scrollTrigger: {
            trigger: ".section#section-1",
            start: "top 75%",
            end: "center center",
            scrub: true,
            once: false,
        },
    })
}